export const FETCH_UPDATE_ERROR = 'FETCH_UPDATE_ERROR';
export const FETCH_UPDATE_SUCCESS = 'FETCH_UPDATE_SUCCESS';
export const FETCH_UPDATE_PASSWORD_SUCCESS = 'FETCH_UPDATE_PASSWORD_SUCCESS';
